import { AutoMap } from "@automapper/classes";

export class CompetenceDTO {
    @AutoMap()
    name!: string;
}